/**
 * The two ways to reach us about security, at the foot of every Security
 * page: a vulnerability goes to the security inbox under the disclosure
 * policy; a problem with your own account goes to support.
 */
import { Link } from 'react-router-dom';
import { ArrowRight, Bug, LifeBuoy } from 'lucide-react';
import { SECURITY_EMAIL } from '@/constants/support';

export const PANEL = 'rounded-2xl border border-white/10 bg-gradient-to-b from-white/[0.05] to-white/[0.015]';

const ICON_WRAP = 'flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-[#7A8ABF]/15 ring-1 ring-[#7A8ABF]/30';

export default function SecurityReportPanel() {
  return (
    <div className="grid gap-4 md:grid-cols-2">
      <div className={`${PANEL} flex flex-col px-6 py-6`}>
        <div className={ICON_WRAP}>
          <Bug className="h-5 w-5 text-[#C9D0EA]" strokeWidth={1.5} aria-hidden />
        </div>
        <p className="mt-4 text-[18px] font-medium text-white">Found a vulnerability?</p>
        <p className="mt-1.5 flex-1 text-[14.5px] leading-relaxed text-white/65">
          Email{' '}
          <a href={`mailto:${SECURITY_EMAIL}`} className="text-[#AAB4D6] underline decoration-white/25 underline-offset-2 hover:text-white">{SECURITY_EMAIL}</a>.
          {' '}Research that follows our disclosure policy is covered by our safe harbor.
        </p>
        <Link
          to="/security/responsible-disclosure"
          className="mt-5 inline-flex items-center gap-2 self-start rounded-full bg-white px-5 py-2.5 text-[14px] font-medium text-black hover:bg-white/90"
        >
          Read the policy <ArrowRight className="h-4 w-4" aria-hidden />
        </Link>
      </div>
      <div className={`${PANEL} flex flex-col px-6 py-6`}>
        <div className={ICON_WRAP}>
          <LifeBuoy className="h-5 w-5 text-[#C9D0EA]" strokeWidth={1.5} aria-hidden />
        </div>
        <p className="mt-4 text-[18px] font-medium text-white">Something wrong with your account?</p>
        <p className="mt-1.5 flex-1 text-[14.5px] leading-relaxed text-white/65">
          A charge, booking or change you don’t recognize? Reset your password, then contact us right away.
        </p>
        <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-3">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 rounded-full border border-white/20 px-5 py-2.5 text-[14px] font-medium text-white hover:bg-white/[0.06]"
          >
            Contact us <ArrowRight className="h-4 w-4" aria-hidden />
          </Link>
          <Link to="/security/account-protection" className="text-[14px] text-[#AAB4D6] hover:text-white">
            What to do first
          </Link>
        </div>
      </div>
    </div>
  );
}
